import { useState, useRef, useEffect } from "react";
import InterviewScoreModal from "./InterviewScoreModal.js";


const InterviewPlayer = ({videoRef,mediaRecorderRef,audioRecorderRef,recordedChunksRef,recordedAudioChunksRef,zoho_lead_id,question_id,last_question_id,encoded_interview_link_send_count,}) => {
  const [showPopup, setShowPopup] = useState(false);
  const [answerScore, setAnswerScore] = useState(null);
  const encoded_zoho_lead_id = btoa(zoho_lead_id)

  const handleCloseModal = () => {
    setShowPopup(false);
  };


  return (
    <div>

      {/* Video Preview */}
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
          style={{ display:'block', margin:'0 auto', borderRadius:'10px',width:'300px', height:'250px', objectFit:'cover'}}      ></video>

      {/* Scrolling Questions */}

      {/* Popup Message */}
      {showPopup && (
        <InterviewScoreModal
          showPopup={showPopup}
          answerScore={answerScore}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default InterviewPlayer;
